// extracted by mini-css-extract-plugin
export var calanderIcon = "HomepageBookingForm-module--calanderIcon--NIbzC";
export var checkboxCustom = "HomepageBookingForm-module--checkboxCustom--+gszH";
export var checked = "HomepageBookingForm-module--checked--2R1uq";
export var datePicker = "HomepageBookingForm-module--datePicker--EVk9x";
export var shipIcon = "HomepageBookingForm-module--shipIcon--GNLbO";
export var tooltipInfoIcon = "HomepageBookingForm-module--tooltipInfoIcon--GnTF6";
export var tooltipQuestionIcon = "HomepageBookingForm-module--tooltipQuestionIcon--nhr4D";
export var unchecked = "HomepageBookingForm-module--unchecked--uRtgn";